import { render, staticRenderFns } from "./translationOpenDataText.vue?vue&type=template&id=b19d6f2c&scoped=true&"
import script from "./translationOpenDataText.vue?vue&type=script&lang=js&"
export * from "./translationOpenDataText.vue?vue&type=script&lang=js&"
import style0 from "./translationOpenDataText.vue?vue&type=style&index=0&id=b19d6f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b19d6f2c",
  null
  
)

export default component.exports